import { MultiSelect } from "primereact/multiselect";
import { useEffect, useState, useRef } from "react";
import { InputText } from "primereact/inputtext";

import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme

import './SelectSeguro.css';

const SelectSeguro = ({
  option,
  option2,
  setOption2,
  selection,
  setSelection,
  buscador = true,
  colorError = false,
  disableds = true,
  maxList = 7

}) => {


  const [selecionado, setSeleccionado] = useState([]);
  const [filterValue, setFilterValue] = useState("");

  const filterInputRef = useRef();



  useEffect(() => {


    setSelection(selecionado?.slice(-1));




  }, [selecionado]);

  useEffect(() => {

  }, [selection])


  const handleChange = (value) => {

    document.querySelector(".p-multiselect-close")?.click()

    setSeleccionado(value);


  };

  const handleShow = (e) => {
    document.querySelector(".p-multiselect-header")?.remove();

  };



  const filterTemplate = (options) => {
    let { filterOptions } = options;

    return (
      <div className="p-multiselect-filter-container">
        <InputText
          className="p-inputtext p-component p-filled p-multiselect-filter"
          value={filterValue}
          ref={filterInputRef}
          placeholder="Buscar..."
          onChange={(e) => myFilterFunction(e, filterOptions)}

        />

      </div>
    );
  };



  const myFilterFunction = (event, options) => {
    let _filterValue = event.target.value;

    selection.length > 0 && setSelection([]);

    const result = option.filter((item) => item.name.toLowerCase().includes(_filterValue.toLowerCase()));
    let resultSlice = result.slice(0, maxList);


    setOption2(resultSlice)
    setFilterValue(_filterValue);


  };


  if (buscador) {
    return (
      <MultiSelect
        filterTemplate={filterTemplate}
        className={`${colorError && "colorrequerido"}`}
        value={selection == null || selection == [null] ? [] : selection}
        options={option2 || []}
        filter
        onChange={(e) => {
          handleChange(e.value);

        }}
        showSelectAll={true}
        filterPlaceholder="Buscar..."
        optionLabel="name"
        optionValue="code"
        maxSelectedLabels={1}
        placeholder="Seleccione"
        disabled={disableds}
        onShow={(e) => {

        }}
      />
    );
  } else {
    return (
      <MultiSelect
        className={`${colorError && "colorrequerido"}`}
        value={selection == null || selection == [null] ? [] : selection}
        options={option || []}
        onChange={(e) => handleChange(e.value)}
        showSelectAll={true}
        optionLabel="label"
        maxSelectedLabels={1}
        placeholder={option[0]?.label}
        onShow={(e) => {
          handleShow();
        }}
      />
    );
  }

};

export default SelectSeguro;
